import * as React from "react";
const SvgChangePassword = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "change_password_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "change_password_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12 11v3",
	style: { fill: "#fff" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M14 3h-4a2 2 0 0 0-2 2v3h8V5a2 2 0 0 0-2-2",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18 7V5a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v2H4.2A2.19 2.19 0 0 0 2 9.2v10.6A2.19 2.19 0 0 0 4.2 22h15.6a2.19 2.19 0 0 0 2.2-2.2V9.2A2.19 2.19 0 0 0 19.8 7ZM8 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2H8Zm12 15H4V9h16Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m6 15.87 1.22-.79-.06 1.46h.69l-.07-1.46 1.23.79.35-.61-1.3-.65 1.3-.67-.35-.59-1.23.79.07-1.46h-.69l.06 1.46L6 13.35l-.35.59 1.3.67-1.3.65zM10.32 15.87l1.22-.79-.06 1.46h.69l-.07-1.46 1.23.79.35-.61-1.3-.65 1.3-.67-.35-.59-1.23.79.07-1.46h-.69l.06 1.46-1.22-.79-.35.59 1.3.67-1.3.65zM14.64 15.87l1.22-.79-.06 1.46h.69l-.07-1.46 1.23.79.35-.61-1.3-.65 1.3-.67-.35-.59-1.23.79.07-1.46h-.69l.06 1.46-1.22-.79-.35.59 1.3.67-1.3.65z",
	style: { fill: "currentColor" }
}))));
export default SvgChangePassword;
